import { combineReducers } from '@reduxjs/toolkit';
/* eslint-disable  import/no-cycle */
import { appNotifications } from 'api/appLevelNotification';
import { appMenu } from 'components/AppMenu/appMenu';
import { auth } from 'features/Auth/auth';
import { components } from 'features/ProductComponents/components';
import { customers } from 'features/Customers/customers';
import { customerDetails } from 'features/CustomerDetails/customerForm';
import { documents } from 'features/Documents/documents';
import { documentsLink } from 'features/Documents/LinkToResource/documentsLink';
import { products } from 'features/Products/products';
import { productForm } from 'features/ProductDetails/productForm';
import { profile } from 'features/Profile/profiles';
import { serialNumbers } from 'features/SerialNumbers/serialNumbers';
import { sites } from 'features/Sites/sites';
import { users } from 'features/Users/users';
import { ordersList } from 'features/OrdersList/ordersList';
import { ordersListForm } from 'features/OrdersList/ordersListForm';
import { productFormTabs } from 'components/NavBar/productFormTabs';
import { preview } from 'features/Preview/previews';
import { reports } from 'features/Reports/reports';
import { reportTemplates } from 'features/ReportTemplates/reportTemplates';

const rootReducer = combineReducers({
  appNotifications,
  appMenu,
  auth,
  components,
  customers,
  customerDetails,
  documents,
  documentsLink,
  ordersList,
  ordersListForm,
  productForm,
  productFormTabs,
  products,
  profile,
  serialNumbers,
  sites,
  users,
  preview,
  reports,
  reportTemplates
});

export type RootState = ReturnType<typeof rootReducer>;

export { rootReducer };
